import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image } from "react-bootstrap";
import DonationsOne from "../../../assests/images/donations-images/donations-1.webp";
import DonationsTwo from "../../../assests/images/donations-images/donations-2.webp";
import {
    RaiseMoneySection,
    CheckYourDonationsSection,
    CheckYourDonationsTitle,
    CheckYourDonationsText,
    CheckYourDonationsStrong,
    DonationsBoxWrap,
    DonationsBox,
    DonationsCount,
    DonationsContent,
    DonationsContentStrong,
    DonationImage,
    CheckYourDonationsStrongBlack,
    ReviewSpanText,
} from "./donationsStyle"
import {
    Title,
    WriteReviewSection,
    ReviewText,
    ReviewRightSection,
    RightBanner,
} from "../../../components/common/commonSubBanner/commonSubBannerStyle";
import DonationsBanner from "../../../assests/images/donations-banner.webp";
import { useNavigate } from "react-router-dom";
import { MESSAGE } from "../../../utils/message";
import MetaComponent from "../../../components/common/metaComponent";
import { openInNewTab } from "../../../utils/functions";
const Donations = () => {
    const navigate = useNavigate();
    return (
        <>
            <MetaComponent
                keywords=""
                description=""
                ogTitle="Donations for Nonprofits | GreatNonprofits"
                ogDescription=""
                ogUrl="https://www.about.greatnonprofits.org/donations"
                ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
            />

            <>
                <RaiseMoneySection>
                    {/* <CommonSubBanner/> */}
                    <WriteReviewSection>
                        <Container className="cont-w">
                            <Row>
                                <Col lg={6} sm={12} md={12}>
                                    <Title className="raise-money-banner" >{MESSAGE.raiseMoneyNonprofit}</Title>
                                    <ReviewText><strong>{MESSAGE.gatherDonation}</strong></ReviewText>
                                    Gather donations directly from your GreatNonprofits profile page Donations are made to PayPal Giving Fund, an IRS-registered 501(c)(3) public charity, and is subject to PayPal Giving Fund's <ReviewSpanText>policies and terms of service</ReviewSpanText> for donors. PayPal Giving Fund receives the donation, which is typically tax deductible, net of payment processing fees of 1.99% + $0.49. PayPal Giving Fund typically grants funds to recommended charities within 15-45 days, or 90 days, if the charity <ReviewSpanText onClick={() => openInNewTab("https://www.paypal.com/us/webapps/mpp/givingfund/policies/donation-delivery-policy#statement-3")}>isn't enrolled</ReviewSpanText> with PayPal Giving Fund.
                                    {/* <ReviewText className="raise-money-text">Donations are made to PayPal Giving Fund, a 501(c)(3) charity, and is subject to PayPal Giving Fund’s <ReviewSpanText>policies and terms of service</ReviewSpanText> for donors. PPGF receives the donation, which is typically tax deductible, net of payment processing fees of 1.99% + $0.49. GreatNonprofits does not profit from these charges, and the total fees are among the lowest donation processing fees for similar services. PayPal Giving Fund typically grants funds to recommended charities within 15-45 days.</ReviewText> */}
                                </Col>
                                <Col lg={6} sm={12} md={12}>
                                    <RightBanner className="left_banner">
                                        <ReviewRightSection>
                                            <Image src={DonationsBanner} alt="ReviewImage" />
                                        </ReviewRightSection>
                                    </RightBanner>
                                </Col>
                            </Row>
                        </Container>
                    </WriteReviewSection>
                </RaiseMoneySection>

                <CheckYourDonationsSection>
                    <Container className="cont-w">
                        <Row>
                            <Col lg="12">
                                <CheckYourDonationsTitle>{MESSAGE.howToCheckDonation}</CheckYourDonationsTitle>
                                <CheckYourDonationsText>To access your organization's donation reports, you will need to <CheckYourDonationsStrong onClick={() => navigate("/about/get-started")}>claim</CheckYourDonationsStrong>  your nonprofit profile first.</CheckYourDonationsText>
                            </Col>
                        </Row>


                        <Row className="donations-box-wrap">
                            <Col lg="6">
                                <DonationsBoxWrap className="donations-box-odd">
                                    <DonationsBox>
                                        <DonationsCount>01</DonationsCount>
                                        <DonationsContent>After you claim your nonprofit profile, <DonationsContentStrong onClick={() => navigate("/signin")}>log in to GreatNonprofits.org.</DonationsContentStrong></DonationsContent>
                                    </DonationsBox>
                                </DonationsBoxWrap>
                            </Col>

                            <Col lg="6" className="offset-lg-6">
                                <DonationsBoxWrap className="donations-box-even">
                                    <DonationsBox>
                                        <DonationsCount>02</DonationsCount>
                                        <DonationsContent>Scroll over "Hello, [screen name]" on the right-hand side of the page.</DonationsContent>
                                    </DonationsBox>

                                    <DonationImage className="Donation-img">
                                        <Image src={DonationsOne} alt="Donations One" />
                                    </DonationImage>

                                </DonationsBoxWrap>
                            </Col>

                            <Col lg="6">
                                <DonationsBoxWrap className="donations-box-odd">
                                    <DonationsBox>
                                        <DonationsCount>03</DonationsCount>
                                        <DonationsContent>Click "Manage My Nonprofit."</DonationsContent>
                                    </DonationsBox>
                                </DonationsBoxWrap>
                            </Col>

                            <Col lg="6" className="offset-lg-6">
                                <DonationsBoxWrap className="donations-box-even">
                                    <DonationsBox>
                                        <DonationsCount>04</DonationsCount>
                                        <DonationsContent>Click the "Donations" link on the top navigation bar.</DonationsContent>
                                    </DonationsBox>

                                    <DonationImage>
                                        <Image src={DonationsTwo} alt="Donations Two" />
                                    </DonationImage>

                                </DonationsBoxWrap>
                            </Col>

                            <Col lg="12">
                                <DonationsBoxWrap>
                                    <DonationsBox>
                                        <DonationsCount>05</DonationsCount>
                                        <DonationsContent>From there, you’ll see the date of the donation, the donor’s name and e-mail address, and dollar amount, as well as any special requests from the donor. To export a CSV file, click the "Download Report" button.</DonationsContent>
                                    </DonationsBox>
                                </DonationsBoxWrap>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg="12">
                                <CheckYourDonationsTitle>About PayPay Giving Fund</CheckYourDonationsTitle>
                                <CheckYourDonationsText>We have partnered with PayPal Giving Fund, an IRS-registered 501(c)(3) public charity. PayPal Giving Fund receives donations in support of other charities and typically grants those funds to recommended charities within 15-45 days, or 90 days, if the charity <CheckYourDonationsStrongBlack><a href="https://www.paypal.com/us/webapps/mpp/givingfund/policies/donation-delivery-policy#statement-3" rel="noreferrer" target="_blank">isn't enrolled</a></CheckYourDonationsStrongBlack> with PayPal Giving Fund. In the rare event PayPal Giving Fund <CheckYourDonationsStrong><a href="https://www.paypal.com/us/webapps/mpp/givingfund/policies/donation-delivery-policy" target="_blank">can’t fund the donor’s chosen charity,</a></CheckYourDonationsStrong> it will seek to consult the donor before reassigning the funds to a similar charity.</CheckYourDonationsText>
                                <CheckYourDonationsText>View <CheckYourDonationsStrong><a href="https://www.paypal.com/us/webapps/mpp/givingfund/policies/donation-delivery-policy" rel="noreferrer" target="_blank">PayPal Giving Fund’s Donation Delivery Policy here</a>.</CheckYourDonationsStrong> </CheckYourDonationsText>
                            </Col>
                        </Row>

                    </Container>

                </CheckYourDonationsSection>

            </>
        </>
    )
};
export default Donations;